export interface OrganisationAddressForm {
  addressLine1: string;
  addressLine2: string;
  postcode: string;
  town: string;
  county: string;
  country: string;
}

export const EMPTY_ORGANISATION_ADDRESS: OrganisationAddressForm = {
  addressLine1: '',
  addressLine2: '',
  postcode: '',
  town: '',
  county: '',
  country: '',
};
